// extracted by css-extract-rspack-plugin
export default {"left":"Left_left__1urb9","mobile":"Left_mobile__3sFXh","desktop":"Left_desktop__2gEBi"};